import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_select, {
      "model-value": _ctx.modelValue,
      label: "Select member",
      options: _ctx.filteredOptions,
      outlined: "",
      dense: "",
      "emit-value": "",
      "map-options": "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:modelValue', value)),
      "lazy-rules": "",
      "bg-color": "white",
      disable: _ctx.noAvailableMembers,
      onFilter: _ctx.filterFn,
      clearable: "",
      "use-input": ""
    }, {
      option: _withCtx((scope) => [
        _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "person" })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.opt.label), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_label, { caption: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.opt.email), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["model-value", "options", "disable", "onFilter"]),
    (_ctx.noAvailableMembers)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "No available members"))
      : _createCommentVNode("", true)
  ], 64))
}